<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <Sidebar></Sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>Top Sites</h2>
          </a-col>
        </a-row>
        <top-sites></top-sites>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import TopSites from "@/components/Sites/TopSites.vue";

export default {
  name: 'TopSitesIndex',
  components: {
    Sidebar,
    TopSites
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {}
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>
